import { proxy } from "valtio";

export const sbState = proxy({
    visible: true
})


